import React from 'react';
import { css } from '@emotion/react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { border } from '../../constants/constant';
import { colors } from '../../constants/colors';
import { StaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { LinkButtonExternal } from '../LinkButton';

export const ExhibitionDetail = ({ data, id }) => {
    return (
        <div css={anchorLinkStyle} id={id}>
            <div css={[containerStyle]}>
                <div css={[subContentStyle]}>
                    <h2 css={[borderStyle, subTitleStyle]}>作品名</h2>
                    <div css={exhibitionTitleStyle}>{data.title}</div>
                    <div css={creatorStyle}>制作者：{data.creator}</div>
                    {data.link && (
                        <div css={[buttonStyle]}>
                            <LinkButtonExternal
                                title="作品ページ"
                                url={data.link}
                            />
                        </div>
                    )}
                </div>
                <div css={[imageContentStyle]}>
                    <Slider className="slider" {...carousel_settings}>
                        {data.img.map((img) => {
                            return (
                                <ImageConstrained
                                    imageName={img}
                                    alt="project_head_image"
                                    imgStyle={{
                                        objectFit: 'contain',
                                    }}
                                    key={img}
                                />
                            );
                        })}
                    </Slider>
                </div>
            </div>
            <div css={[containerStyle]}>
                <div css={[subContentStyle]}>
                    <h2 css={[borderStyle, subTitleStyle]}>概要</h2>
                    <p
                        css={textStyle}
                        dangerouslySetInnerHTML={{
                            __html: data.about_long,
                        }}
                    ></p>
                </div>
                <div css={[subContentStyle]}>
                    <h2 css={[borderStyle, subTitleStyle]}>作成方法</h2>
                    <p
                        css={textStyle}
                        dangerouslySetInnerHTML={{ __html: data.method }}
                    ></p>
                </div>
            </div>
            {data.movie && (
                <div css={movieHolderStyle}>
                    <iframe
                        css={movieStyle}
                        src={data.movie}
                        title="YouTube video player"
                        frameBorder="0"
                        scrolling="no"
                        allow="accelerometer; clipboard-write;encrypted-media;"
                        allowFullScreen
                    ></iframe>
                </div>
            )}
        </div>
    );
};

const ImageConstrained = (props) => (
    <StaticQuery
        query={graphql`
            query {
                images: allFile {
                    edges {
                        node {
                            relativePath
                            name
                            childImageSharp {
                                gatsbyImageData(width: 450, layout: CONSTRAINED)
                            }
                        }
                    }
                }
            }
        `}
        render={(data) => {
            const image = data.images.edges.find((n) => {
                return n.node.relativePath.includes(props.imageName);
            });
            if (!image) {
                return null;
            }
            return (
                <GatsbyImage
                    image={getImage(image.node)}
                    alt={props.alt}
                    style={props.style}
                    imgStyle={props.imgStyle}
                />
            );
        }}
    />
);

const carousel_settings = {
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const breakPoint = '720px';

const anchorLinkStyle = css`
    margin-top: -56px;
    padding-top: 56px;
`;

const buttonStyle = css`
    margin-bottom: 32px;
`;

const subTitleStyle = css`
    font-size: 24px;
    padding-bottom: 4px;
`;

const creatorStyle = css`
    padding-bottom: 16px;
`;

const exhibitionTitleStyle = css`
    font-size: 24px;
`;

const movieHolderStyle = css`
    position: relative;
    margin: 20px auto 32px;
    padding-top: 45%;
    width: 70%;
    height: auto;
    @media only screen and (max-width: ${breakPoint}) {
        width: 90%;
        height: auto;
    }
`;

const movieStyle = css`
    position: absolute;
    margin: 0 auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
`;

const containerStyle = css`
    display: flex;
    flex-wrap: wrap;
    padding-top: 32px;
`;

const subContentStyle = css`
    width: 50%;
    padding: 0 16px;
    @media only screen and (max-width: ${breakPoint}) {
        width: 100%;
        margin: 0;
    }
`;

const imageContentStyle = css`
    width: 44%;
    padding: 0 16px;
    margin-left: 3%;
    @media only screen and (max-width: ${breakPoint}) {
        width: 88%;
        margin-left: 6%;
    }
    .slick-dots {
        li.slick-active button:before {
            color: ${colors.white} !important;
        }
        li button:before {
            color: ${colors.white} !important;
        }
    }
`;

const borderStyle = css`
    display: inline-block;
    border-bottom: ${border} solid ${colors.primary};
    padding: 0 4px;
`;

const textStyle = css`
    text-align: justify;
    word-break: break-all;
    a {
        color: ${colors.primary};
        :visited {
            color: ${colors.primary};
        }
    }
`;
